var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinglebrested(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st155{fill:#FFFFFF;stroke:#010101;stroke-miterlimit:10;}\n\t.st154{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st153{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M271.13,74.04c-5.49,36.15-14.35,65.13-21.92,85.72c-16.01,43.63-29.26,57.89-39.19,64.78 c-9.93-6.87-23.18-21.13-39.21-64.78c-7.42-20.19-16.08-48.44-21.6-83.61c16.03,5.41,36.19,8.64,58.06,8.64 C231.87,84.79,254.29,80.71,271.13,74.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M273.13,87.04c-5.49,36.15-14.35,65.13-21.92,85.72c-16.01,43.63-29.26,57.89-39.19,64.78 c-9.93-6.87-23.18-21.13-39.21-64.78c-7.42-20.19-16.08-48.44-21.6-83.61c16.03,5.41,36.19,8.64,58.06,8.64 C233.87,97.79,256.29,93.71,273.13,87.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M109.22,231.02l4.32,1.98c4.55-6.09,1.53-9.79,2.7-22.15c0.85-8.94-1.22-19.75-1.86-22.61 c-3.79-17.26-6.23-48.26-12.53-93.68l-0.31,0.03l7.68,102.19V231.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M313.8,228.02l-2.26-4.02c-4.55-6.09-3.59-3.79-4.76-16.15c-0.85-8.94,1.22-19.75,1.86-22.61 c3.79-17.26,6.23-48.26,12.53-93.68l0.31,0.03l-7.68,102.19V228.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M113.36,187.24c0.64,2.86,2.71,13.66,1.86,22.61c-1.17,12.36-4.94,19.4-9.49,25.49 c-1.1,1.5-2.26,2.95-3.44,4.4c4.36,11.76,9.69,29.64,11.07,51.83c0.96,15.2-0.33,26.06-1.77,39.87 c-1.93,18.53-4.45,45.62-6.64,80.18c25.69,11.96,51.39,23.92,77.08,35.88c5-7.11,10.43-19.5,16.43-25.5c7-7,17.74-16.42,26.02-17.7 c-0.29-55.82-0.58-111.64-0.89-167.45c-8.36-0.7-17.13-5.85-26.13-15.85c-7.95-8.83-8.11-10.28-26-59 c-7.67-20.88-15.85-50.63-21.33-87.5c-16.09,6.19-33.52,10.63-49.61,16.83c0.11,0.74,0.21,1.49,0.31,2.23 C107.13,138.98,109.57,169.98,113.36,187.24z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st155",
    x1: 209.29,
    y1: 97.79,
    x2: 210.54,
    y2: 231.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M309.64,185.24c-0.64,2.86-2.71,13.66-1.86,22.61c1.17,12.36,4.94,19.4,9.49,25.49c1.1,1.5,2.26,2.95,3.44,4.4 c-4.36,11.76-9.69,29.64-11.07,51.83c-0.96,15.2,0.33,26.06,1.77,39.87c1.93,18.53,4.45,45.62,6.64,80.18 c-25.69,11.96-51.39,23.92-77.08,35.88c-5-7.11-10.43-19.5-16.43-25.5c-7-7-17.74-16.42-26.02-17.7 c0.29-55.82,0.58-111.64,0.89-167.45c8.36-0.7,17.13-5.85,26.13-15.85c7.95-8.83,8.11-10.28,26-59 c7.67-20.88,15.85-50.63,21.33-87.5c16.09,6.19,33.52,10.63,49.61,16.83c-0.11,0.74-0.21,1.49-0.31,2.23 C315.87,136.98,313.43,167.98,309.64,185.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 107.99,
    y: 358.09,
    className: "st155",
    width: 53.16,
    height: 4.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.09,
    y: 358.09,
    className: "st155",
    width: 53.16,
    height: 4.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st155",
    x1: 143.43,
    y1: 280.41,
    x2: 145.2,
    y2: 356.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st155",
    x1: 278.19,
    y1: 282.48,
    x2: 276.42,
    y2: 358.09
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st153",
    cx: 210.54,
    cy: 249,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st153",
    cx: 210.54,
    cy: 390,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st153",
    cx: 210.54,
    cy: 318,
    r: 7.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglebrested);
export default __webpack_public_path__ + "static/media/SINGLE BRESTED.fe903271376923982b8ffa2aa4c68003.svg";
export { ForwardRef as ReactComponent };